import { render, staticRenderFns } from "./Official_Duration.vue?vue&type=template&id=53fba261&scoped=true"
import script from "./Official_Duration.vue?vue&type=script&lang=js"
export * from "./Official_Duration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fba261",
  null
  
)

export default component.exports